/**
 * StatusEnum is used to track the status of integrations
 * This is a temporary workaround for import issues with the shared-types package
 */
export enum StatusEnum {
  NOT_COMPLETED = "Not Completed",
  ACTIVE = "Active",
  PAUSE = "Pause",
  ERROR = "Error",
} 